import { render, staticRenderFns } from "./VueFileUpload.vue?vue&type=template&id=38b62e6a&"
import script from "./VueFileUpload.vue?vue&type=script&lang=js&"
export * from "./VueFileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports